
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';

const AccessDeniedProject = (props) => {

    const classNames = mergeStyleSets({
        root: {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 0',
            alignItems: 'center'
        },
        info: {
            paddingTop: 8
        }
    });

    return (
        <div className={classNames.root}>
            <div className={classNames.info}>Projekt nelze zobrazit protože pro požadovanou funkcionalitu neobsahuje potřebná data.</div>
        </div>
    );
}

export default AccessDeniedProject;
